import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Layout from './Layout';

import Home from '../pages/Home';
import Lessons from '../pages/Lessons';
import Contact from '../pages/Contact';



function App() {
  return (
    <React.Fragment>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/calmyoga/" element={<Home />} exact />
            <Route path="/lessons/" element={<Lessons />} exact />
            <Route path="/contact/" element={<Contact />} exact />
          </Routes>
        </Layout>
      </BrowserRouter>
    </React.Fragment>

  );
}



export default App;